import { Injectable } from '@angular/core';

import { KnowledgeBaseScrapeJob } from 'src/models';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class KnowledgeBaseScrapeJobsService extends GenericObjectsService<KnowledgeBaseScrapeJob> {
  protected baseUrl = '/knowledge-base/scrape-jobs';
}
